import React, { createContext, useContext, useState } from "react";
import t from "./translations";

const SUPPORTED = ["es", "en", "pt", "fr", "de"];

function detectLang() {
  const saved = localStorage.getItem("aiveo_lang");
  if (saved && SUPPORTED.includes(saved)) return saved;
  const browser = (navigator.language || "es").slice(0, 2).toLowerCase();
  return SUPPORTED.includes(browser) ? browser : "es";
}

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);

  const setLang = (l) => {
    if (!SUPPORTED.includes(l)) return;
    localStorage.setItem("aiveo_lang", l);
    setLangState(l);
  };

  const tr = t[lang] || t.es;

  return (
    <LanguageContext.Provider value={{ lang, setLang, tr, SUPPORTED }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
